import * as React from "react";
const SvgCakeDecorator = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 56, height: 51, viewBox: "0 0 56 51", fill: "none", ...props }, "...");
export default SvgCakeDecorator;
